import React, { useEffect, useState } from 'react'
import Select, { components } from 'react-select';
import $ from "jquery";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import LinkBanner1 from "../../assets/link-acct-1.svg";
import LinkBanner2 from "../../assets/link-acct-2.svg";
import LinkBanner3 from "../../assets/link-acct-3.svg";
import LinkBanner4 from "../../assets/link-acct-4.svg";
import LinkUser from "../../assets/link-user.svg";
import Pic1 from "../../assets/Pic1.png";
import Pic2 from "../../assets/Pic2.png";
import Pic3 from "../../assets/Pic3.png";
import footerLogo from "../../assets/josh-logo-footer.svg";
import pinMark from "../../assets/pin-mark.svg";
import Close_black from "../../assets/close_black.svg";
import Close_white from "../../assets/white-close.svg";
import instaLinkImg from "../../assets/instagram-link.svg";
import socialIcon1 from "../../assets/insta-icon.svg";
import socialIcon2 from "../../assets/facebook-icon.svg";
import socialIcon3 from "../../assets/youtube-icon.svg";
import socialIcon4 from "../../assets/twitter-icon.svg";
import { isValidUrl } from '../../utils/common';
import _ from "lodash";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useToast } from '../../toast';
import { CREACTOR_DETAILS, PROFILE_DETAILS, REGISTER_DETAILS } from '../../redux/action_type';
import { addOldAccount, checkLoginApi, getAppProfileInfo, onAddCreator, onCheckValidateCreator } from '../../services';
import { onGetProfileDetails, onJustReducerUpdate } from '../../redux/action';
import IsLoadingHOC from '../HOC/loader/IsLoadingHOC';
import Login from '../auth/Login';
import Header from '../common/Header';
import { detectIncognito } from "detectincognitojs";
import FingerprintJS from '@fingerprintjs/fingerprintjs'

const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

function LinkAccountNew(props) {
    const socialMediaOptions = [
        { value: 'instagram', label: 'Instagram', icon: socialIcon1 },
        { value: 'facebook', label: 'Facebook', icon: socialIcon2 },
        { value: 'youtube', label: 'Youtube', icon: socialIcon3 },
    ]
    const profileDetails = useSelector((state) => state.profileDetails)
    const profileDetailsLoading = useSelector((state) => state.profileDetailsLoading)
    const loginDetails = useSelector((state) => state.loginDetails)
    const toast = useToast();
    const dispatch = useDispatch()
    const history = useHistory();
    let query = useQuery();

    const { Option } = components;
    const [isDisabled, setIsDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRtl, setIsRtl] = useState(false);
    const [selectedOption, setSelectedOption] = useState({ value: 'instagram', label: 'Instagram' });
    const [channelName, setChannelName] = useState("");
    const prefix = '@'
    const { setLoading } = props;
    let authData = localStorage.getItem(REGISTER_DETAILS)
    authData = JSON.parse(authData)
    const isLoginPopup = JSON.parse(localStorage.getItem("isLoginPopup") || "false")
    useEffect(() => {
        window.resume = resume;
        if (isLoginPopup && _.isEmpty(authData)) {
            $("#login-popup").modal("show")
            localStorage.removeItem("isLoginPopup")
        }

    }, [isLoginPopup])
    // useEffect(() => {
    //     setLoading(profileDetailsLoading)
    // }, [profileDetailsLoading])

    // useEffect(() => {
    //     if (loginDetails?.is_insert) {
    //         $("#name-update-popup").modal("show")
    //     }
    // }, [loginDetails])

    // useEffect(() => {
    //     if (profileDetailsLoading || _.isEmpty(profileDetails)) {
    //         return
    //     }
    //     if ((profileDetails?.cp_creators?.length === 0 || !profileDetails?.cp_creators?.length) && !profileDetailsLoading) {
    //         history.push("/link-account");
    //     } else if (!profileDetailsLoading && !_.isEmpty(profileDetails?.cp_creators)) {
    //         const { publisher_id, is_linked } = profileDetails?.cp_creators?.[0]
    //         if (is_linked) {
    //             history.push("/dashboards");
    //             return
    //         } else {
    //             setLoading(true)
    //             addOldAccount({ publisher_id, is_deleted: true }).then(responseData => {
    //                 setLoading(false)
    //                 if (responseData.status) {
    //                     dispatch(onGetProfileDetails(authData.josh_user_id))
    //                 }
    //             }).catch(err => console.log("err3", err))
    //         }
    //     }
    // }, [profileDetails, profileDetailsLoading])

    const IconOption = props => {
        return (
            <Option {...props} className="select-option">
                <img
                    className='drop-down-img'
                    src={props?.data?.icon}
                    style={{ width: 36 }}
                    alt={props.data.label}
                />
                {props.data.label}
            </Option>
        )
    };

    const handleChange = (e) => {
        setSelectedOption(e);
    };

    const onCheck = () => {
        let contructChannelName = channelName.split("/")?.filter(n => n)?.slice(-1).pop()
        if (!contructChannelName || !profileDetails?.name || !selectedOption?.value) {
            toast.open("Please add the profile name", "warn")
            console.log("please check the values")
            return
        }
        setLoading(true)
        contructChannelName = contructChannelName.split("@")?.slice(-1).pop()
        let payload = {
            "publisher_name": profileDetails?.name,
            "network": selectedOption?.value,
            "userid": contructChannelName
        }
        onCheckValidateCreator(payload).then((res) => {
            if (res.status) {
                const validateResponse = res.data
                if (validateResponse.new_status && validateResponse.is_delete) {
                    payload = { ...payload, is_delete: true, publisher_id: validateResponse.publisher_id, socialNetworkId: validateResponse?.socialNetworkId }
                    onAddCreator(payload).then((response) => {
                        setLoading(false)
                        $("#link-account-popup-1").modal("hide");
                        setSelectedOption([])
                        setChannelName("")
                        if (response.status) {
                            toast.open("Account added successfully")
                            dispatch(onJustReducerUpdate(response.data, CREACTOR_DETAILS))
                            history.push("/account-authentication")
                        }
                    }).catch((e) => setLoading(false))
                } else if (validateResponse.new_status && !validateResponse.is_delete) {
                    payload = { ...payload, is_delete: false, publisher_id: 0, socialNetworkId: validateResponse?.socialNetworkId }
                    onAddCreator(payload).then((response) => {
                        setLoading(false)
                        $("#link-account-popup-1").modal("hide");
                        setSelectedOption([])
                        setChannelName("")
                        if (response.status) {
                            toast.open("Account added successfully")
                            dispatch(onJustReducerUpdate(response.data, CREACTOR_DETAILS))
                            history.push("/account-authentication")
                        }
                    }).catch((e) => setLoading(false))
                } else if (validateResponse.error) {
                    setLoading(false)
                    toast.open(res?.message, "error")
                    $("#link-account-popup-1").modal("hide");
                    setSelectedOption([])
                    setChannelName("")
                }
            } else {
                setLoading(false)
                toast.open(res?.message, "error")
            }
        }).catch((err) => {
            setLoading(false)
            console.log("err", err)
        })
    }

    const onValueChange = (value) => {
        setChannelName(value)
    }

    const checkLogin = async (status) => {
        try {
            setLoading(true);
            const fpPromise = FingerprintJS.load()
            fpPromise
                .then(fp => fp.get())
                .then(result => {
                    const visitorId = result.visitorId
                    let payload = {
                        "device_id": visitorId
                    }
                    detectIncognito().then((result) => {
                        checkLoginApi({ ...payload, is_incognito: result.isPrivate }).then(async (res) => {
                            setLoading(false);
                            if (res.status) {
                                setLoading(false)
                                dispatch(onJustReducerUpdate(res.data, REGISTER_DETAILS))
                                localStorage.setItem(REGISTER_DETAILS, JSON.stringify(res.data))
                                history.push("/dashboards");
                            }
                            else if (res?.status === false){
                                setLoading(false)
                                if(status==="true"){
                                $("#login-popup").modal("show")
                                }
                              }
                        }).catch((err) => setLoading(false))

                    }).catch((err) => setLoading(false));

                })
        } catch (error) {
            setLoading(false);
        }
    }

    const onClose = (status) => {
        setSelectedOption({ value: 'instagram', label: 'Instagram' })
        setChannelName("")
        // const isFromMobileApp = query.get("isFromMobileApp")
        // if (JSON.parse(isFromMobileApp)) {
        //     console.log("isFromMobileApp")
        if (window?.newsHuntAction) {
            window?.newsHuntAction.onInvokeLogin()
            return
        }
        // }
        checkLogin(status)
        // $("#login-popup").modal("show")
    }
    const resume = () => {
        if (typeof window?.newsHuntAction != 'undefined' && typeof window?.newsHuntAction.isLoggedIn != 'undefined') {
            const isLoggedIn = window?.newsHuntAction?.isLoggedIn()
            if (isLoggedIn) {
                if (window?.newsHuntAction) {
                    var getClientIdValue = ""
                    if (window?.newsHuntAction?.getClientId) {
                        getClientIdValue = window?.newsHuntAction?.getClientId()
                    }
                    var getUniqueAuthTokenValue = ""
                    if (window?.newsHuntAction?.getUniqueAuthToken) {
                        getUniqueAuthTokenValue = window?.newsHuntAction?.getUniqueAuthToken()
                    }
                    var getUserIdValue = ""
                    if (window?.newsHuntAction?.getUserId) {
                        getUserIdValue = window?.newsHuntAction?.getUserId()
                    }
                    let constructData = { ...authData, josh_client_id: getClientIdValue, token: getUniqueAuthTokenValue, josh_user_id: getUserIdValue, id: "" }
                    console.log("123construct", constructData)
                    localStorage.setItem(REGISTER_DETAILS, JSON.stringify(constructData))
                    getAppProfileInfo(getUserIdValue).then(res => {
                        console.log("123constructres", res)
                        localStorage.setItem(REGISTER_DETAILS, JSON.stringify(res.data))
                        history.push("/dashboards");
                        return
                    })
                }
            }
        }
    }
    // if (profileDetailsLoading || !_.isEmpty(profileDetails?.cp_creators)) {
    //     return
    // }

    const handleKeyPress = (e) => {
        if (e.keyCode === 13 && e.target.value != "") {
            onCheck()
        }
    }
    return (
        <>
            <Header />
            {/* <div
                className="modal fade logout-popup-wrap session-popup name-session-wrap"
                id="name-update-popup"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                data-backdrop="static"
                data-keyboard="false"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered custom-popup " role="document">
                    <div className="modal-content   ">
                        <div className="modal-body pt-0 mt-3">
                            <div className='logout-card'>
                                <p>Since you've signed in through a mobile number, we strongly recommend you set a valid user name initially. It is important as this user name will eventually be used in your media kit.</p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className='common-btn'>
                                <button className='bg-btn' data-dismiss="modal" data-toggle="modal" data-target="#edit-profile">Ok</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className='new-link-account-wrap'>
                <div className='link-account-banner'>
                    <div className='row'>
                        <div className='col-md-7'>
                            <div className='link-account-content'>
                                <h2>One stop solution to <br />
                                    <span>Grow & Monetize</span> your audience</h2>
                                <div className='free-tag'>
                                    <p> and it’s FREE!!</p>
                                </div>
                                <span>Link your social accounts on CreatorPro and get associated with top 10000+ brands for collaborations and affiliate opportunities</span>
                            </div>
                            <div className='common-btn'>
                                <button onClick={()=>onClose("true")} data-toggle="modal"> Login</button>
                            </div>
                        </div>
                        <div className='col-md-5'>
                            <div className='link-banner-right'>
                                <img src={LinkBanner1} alt="" />
                            </div>
                        </div>
                    </div>

                </div>
                <div className='counter-wrap'>
                    <h2>One stop destination for social media influencers</h2>
                    <div className='container'>
                        <OwlCarousel
                            className="owl-theme counter-slider"
                            loop={true}
                            margin={20}
                            nav={false}
                            autoWidth={false}
                            autoplay={true}
                            dots={true}
                            responsive={{
                                0: {
                                    items: 1,
                                },
                                600: {
                                    items: 1,
                                },
                                1000: {
                                    items: 1,
                                },
                            }}
                        >
                            <div className="item">
                                <div className='counter-card'>
                                    <p>1Mn+</p>
                                    <span>Creators</span>
                                </div>
                            </div>
                            <div className="item"> <div className='counter-card'>
                                <p>10000+</p>
                                <span>Brands</span>
                            </div></div>
                            <div className="item"> <div className='counter-card'>
                                <p>1000+</p>
                                <span>Campaign Invitations</span>
                            </div> </div>
                            <div className="item"> <div className='counter-card'>
                                <p>₹10000</p>
                                <span>Earn every month</span>
                            </div> </div>

                        </OwlCarousel>
                        <div className='row mobile-hide'>
                            <div className='col-md-3'>
                                <div className='counter-card'>
                                    <p>1Mn+</p>
                                    <span>Creators</span>
                                </div>
                            </div>
                            <div className='col-md-3'>
                                <div className='counter-card'>
                                    <p>10000+</p>
                                    <span>Brands</span>
                                </div>
                            </div>
                            <div className='col-md-3'>
                                <div className='counter-card'>
                                    <p>1000+</p>
                                    <span>Campaign Invitations</span>
                                </div>
                            </div>
                            <div className='col-md-3'>
                                <div className='counter-card no-boder'>
                                    <p>₹10000</p>
                                    <span>Earn every month</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='what-for-you-wrap'>
                    <h2>What’s in for you</h2>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="what-for-content">
                                <p>Collaboration Invites</p>
                                <span>Get invited from over 10000+ Brands for the campaign <br /> associations and monetization opportunities. </span>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="what-for-banner">
                                <img src={LinkBanner2} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="what-for-banner">
                                <img src={LinkBanner3} alt="" />
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="what-for-content">
                                <p>Media Kit & Social Insights</p>
                                <span>Get detailed performance insights on all linked Social <br /> accounts with easy share account reports.</span>
                            </div>
                        </div>

                    </div>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="what-for-content">
                                <p>Creator's Affiliate Store</p>
                                <span>Access to 20000+ affiliate products from top brands. <br /> Grow your social profile & earn money while creating content.
                                </span>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="what-for-banner">
                                <img src={LinkBanner4} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='creater-slider-wrap'>
                    <OwlCarousel
                        className="owl-theme user-link-crousel"
                        loop={true}
                        margin={20}
                        nav={false}
                        autoWidth={false}
                        autoplay={true}
                        responsive={{
                            0: {
                                items: 1,

                            },
                            600: {
                                items: 1,

                            },
                            1000: {
                                items: 1,
                            },
                        }}
                    >
                        <div className="item">
                            <div className='creater-slider-card'>
                                <div className='link-user-image'>
                                    <img src={Pic2} alt="" />
                                </div>
                                <div className='creater-slider-content'>
                                    <span> I was finding it difficult to track and follow trending brand campaigns with my college workload. Creator Pro performance report helped me to reach out and get shortlisted for branded campaigns.</span>

                                    <p>- Mansi, Josh Creator </p>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className='creater-slider-card'>
                                <div className='link-user-image'>
                                    <img src={Pic1} alt="" />
                                </div>
                                <div className='creater-slider-content'>
                                    <span>I have recently started my journey as an influencer. My friend recommended this platform to track my performance and grow in the social media space. The analytics and insights helped me monitor my performance across different social media platforms.</span>
                                    <p>- Dipali, Instagram Creator</p>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className='creater-slider-card'>
                                <div className='link-user-image'>
                                    <img src={Pic3} alt="" />
                                </div>

                                <div className='creater-slider-content'>
                                    <span>CreatorPro was attractive for me because of the free social performance report which gives real-time insights. I shared this report with multiple brands and got invitations for various campaigns.</span>
                                    <p>- Rahul, Youtube Creator</p>
                                </div>
                            </div>
                        </div>
                    </OwlCarousel>
                </div>
                <div className='get-start-section'>
                    <h2>Get Started!</h2>
                    <p> Ready to grow with CreatorPro. We are excited to have you onboard. Link your account and access the free social performance report and improve your chances of getting invited for branded campaigns.
                    </p>
                    <div className='common-btn'>
                        <button onClick={()=>onClose("true")} data-toggle="modal"> Login</button>

                    </div>
                </div>
            </div>
            <div
                className="modal fade logout-popup-wrap link-account-popup"
                id="link-account-popup-1"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                data-backdrop="static"
                data-keyboard="false"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered custom-popup " role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Link Account
                            </h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span aria-hidden="true">
                                    <img className="closeModal" src={Close_black} alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body ">
                            <div className='link-account-popup-wrap'>
                                <img src={instaLinkImg} alt="" />
                                <p>Add your primary social account handle for brand campaigns</p>
                                <div className='link-account-options'>
                                    <div className='form-group'>
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            isDisabled={isDisabled}
                                            isLoading={isLoading}
                                            isClearable={false}
                                            isRtl={isRtl}
                                            isSearchable={false}
                                            options={socialMediaOptions}
                                            name="color"
                                            onChange={handleChange}
                                            value={selectedOption}
                                            components={{ Option: IconOption }}
                                            formatOptionLabel={data => {
                                                return (
                                                    <div className="country-option">
                                                        <img
                                                            className='drop-down-img-label'
                                                            src={data.value === "instagram" ? socialIcon1 : data.value === "facebook" ? socialIcon2 : data.value === "youtube" ? socialIcon3 : socialIcon4}
                                                            style={{ width: 36 }}
                                                            alt={data.label}
                                                        />
                                                    </div>
                                                )
                                            }}
                                        />
                                        <input
                                            type="text"
                                            className="form-control"
                                            onKeyDown={handleKeyPress}
                                            onChange={(e) => {
                                                const input = e.target.value
                                                if (isValidUrl(input)) {
                                                    e.target.value = input
                                                } else {
                                                    setChannelName((prev) => {
                                                        if (prev.length === 0) {
                                                            e.target.value = prefix + input
                                                        } else {
                                                            e.target.value = prefix
                                                            if (input.length > 0) {
                                                                e.target.value = prefix + input.substr(prefix.length)
                                                            } else {
                                                                e.target.value = ""
                                                            }
                                                        }
                                                        onValueChange(e.target.value)
                                                        return
                                                    })
                                                }
                                                onValueChange(e.target.value)
                                            }}
                                            value={channelName}
                                            placeholder={`Enter your user handle or username`}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className='common-btn'>
                                <button type='button' className={`${!channelName ? "link-btn-disabled" : ""}`} disabled={!channelName} onClick={onCheck}><img src={pinMark} alt="" /> Link Account</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div
                className="modal fade logout-popup-wrap"
                id="login-popup"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="login-popupLabel"
                data-backdrop="static"
                data-keyboard="false"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered custom-popup " role="document">
                    <Login />
                </div>
            </div> */}
            <div class="modal fade login-modal-common" id="login-popup" tabIndex="-1"
                role="dialog"
                aria-labelledby="login-popupLabel"
                data-backdrop="static"
                data-keyboard="false"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"><img src={Close_white} alt="" /></span>
                            </button>
                            <Login />
                        </div>

                    </div>
                </div>
            </div>
            <div className='josh-footer-wrap'>
                <span> Powered by</span>
                <img src={footerLogo} alt="" />
            </div>
        </>
    )
}

export default IsLoadingHOC(LinkAccountNew)